import React from 'react';

const Filtros = props => (
  <div className='pageHead-rowContainer'>
    <div className='pageHead-filters wrapper'>
      <div className='row'>
        <div className='col-md-4'>
          <label className='labelInfo' htmlFor='sucursalDespacho'>Sucursal de Despacho</label>
          <div className='select'>
            <select className='form-control' id='sucursalDespacho' onChange={props.onChangeAndFilter} name='sucursalDespacho' value={props.sucursalDespacho}>
              <option value=''>Selecciona una sucursal</option>
              {
                props.sucursales.map(sucursal => (
                  <option
                    key={sucursal.codSucursal}
                    value={sucursal.codSucursal}
                  >
                    {sucursal.nomSucursal}
                  </option>
                ))
              }
            </select>
            <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
          </div>
        </div>
        <div className='col-md-4'>
          <label className='labelInfo' htmlFor='sucursalEntrega'>Sucursal de Entrega</label>
          <div className='select'>
            <select className='form-control' id='sucursalEntrega' onChange={props.onChangeAndFilter} name='sucursalEntrega' value={props.sucursalEntrega}>
              <option value=''>Selecciona una sucursal</option>
              {
                props.sucursales.map(sucursal => (
                  <option
                    key={sucursal.codSucursal}
                    value={sucursal.codSucursal}
                  >
                    {sucursal.nomSucursal}
                  </option>
                ))
              }
            </select>
            <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
          </div>
        </div>
        <div className='col-md-4'>
          <label className='labelInfo' htmlFor='cantidadDias'>Cantidad de dias</label>
          <div className='fSearch'>
            <input
              type='number'
              min='1'
              name='cantidadDias'
              className='fSearch-search form-control'
              placeholder=''
              value={props.cantidadDias}
              onChange={props.onChangeValue}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  props.filter();
                }
              }}
            />
            <button className='btn btn-dark fSearch-go checkDeGrillaCerrar' type='button' onClick={props.filter}>
              <i className='ion-android-arrow-forward' />
            </button>
          </div>
        </div>
      </div>

      <button className='btn pageHead-tableConf-clean checkDeGrillaCerrar' data-toggle='tooltip' data-placement='top' title='Limpiar filtros' data-original-title='Limpiar filtros' onClick={props.reset}>
        <i className='ion-funnel' />
      </button>
    </div>
  </div>
);

export default Filtros;



// WEBPACK FOOTER //
// ./src/pages/MantDiasTraslado/Filtros.js